// This file contains legacy analytics code that needs refactoring
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - Legacy code, will be refactored

interface DataLayerObject {
  eventType?: string | undefined;
  interactionType: string;
  gaComponent?: string;
  label?: string | undefined;
  href?: string | undefined;
  linkContext?: string | undefined;
  position?: string | undefined;
}

interface DataLayerMap {
  event: string;
  interaction__type: string;
  interaction__component?: string;
  interaction__text?: string | undefined;
  interaction__destination?: string | undefined;
  interaction__linkContext?: string | undefined;
  position?: string | undefined;
}

const pushToDataLayer = (dataLayerMap: DataLayerMap) => {
  if (typeof window !== 'undefined') {
    window?.dataLayer?.push(dataLayerMap);
  }
};

const buildDataLayerMap = (dataLayerObject: DataLayerObject): DataLayerMap => {
  const {
    eventType = 'interaction',
    interactionType,
    gaComponent,
    label,
    href,
    linkContext,
    position,
  } = dataLayerObject;

  const dataLayerMap: DataLayerMap = {
    event: eventType,
    interaction__type: interactionType,
    interaction__component: gaComponent,
  };

  label && (dataLayerMap.interaction__text = label);
  href && (dataLayerMap.interaction__destination = href);
  linkContext && (dataLayerMap.interaction__linkContext = linkContext);
  position && (dataLayerMap.position = position);

  //TODO -> add debug flag behavior for non-prod environments
  // console.log("dataLayerMap", dataLayerMap);

  return dataLayerMap;
};

export const dataLayerHandler = (dataLayerObject: DataLayerObject) => {
  //ommitting gaComponent at point of function usage will prevent dataLayer push
  //allows for control of dataLayer push when both parent and child components have dataLayer interactions
  if (!dataLayerObject.gaComponent) {
    return;
  }

  const dataLayerMap = buildDataLayerMap(dataLayerObject);
  pushToDataLayer(dataLayerMap);
};
